import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import ChatBot from "./Components/Shared/ChatBot";
import { ToastContainer } from "react-toastify";

import { relativePath } from "./Constants/config";
import rootReducer from "./reducers/Reducer";

import Routes from "./Routes";
import { TranslationProvider } from "./Hooks/UseTranslation/use-translation";
import "./index.scss";

import TracerInit from './OpenTelemetry/TracerInit';

//Initialize OpenTelemetry Tracer
const InitializeTracer = async () => {
  await TracerInit();
};

InitializeTracer();

const store = createStore(rootReducer);
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
        <Router basename={`${relativePath}`}>
        <TranslationProvider>
          <Routes />
          <ChatBot />
          <ToastContainer />
        </TranslationProvider>
        </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
